import styled from 'styled-components';
import { P14 } from './P14';

export const P14N = styled(P14)`
  font-weight: 400;
`;
